import styled from 'styled-components';
import { DatePicker } from 'antd';
const { RangePicker: AntdRangePicker } = DatePicker;

export const StyledRangePicker = styled(AntdRangePicker)`
  width: 100%;

  .ant-picker-suffix {
    color: transparent !important;
  }

  &.ant-picker-outlined:focus-within,
  &.ant-picker-outlined:focus,
  &.ant-picker-outlined:hover {
    box-shadow: 0 0 0 0.125rem rgb(254, 173, 21, 0.1);
  }
`;
